import "bootstrap/dist/js/bootstrap.min.js";
import "bootstrap/dist/css/bootstrap.min.css";
import { useState, useEffect } from "react";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import Main from "./components/main/main";
import { Login } from "./components/login/login";
import Loader from "./components/common/loader";
import { bootstrapAuth } from "./components/common/functions";
import { useMyStore } from "./components/main/mainStore.jsx";
export const globalProps = { isMouseDown: false };
// globally monitor mouse click event.
window.onmousedown = () => {
    globalProps.isMouseDown = true;
}
window.onmouseup = () => {
    globalProps.isMouseDown = false;
}

// ask if you want to leave the webpage if user close the webpage.
window.onbeforeunload = () => {
    return true; 
}


if(typeof(EventSource) !== "undefined"){
    // Yes! Server-sent events support!
    // Some code.....

    /*

    let source = new EventSource("demo_sse.php");
    source.onmessage = e => {
        console.log(e);
    };

      */

    }else{
    // Sorry! No server-sent events support..  
}

if(typeof(Storage) === "undefined"){
    window.alert("Sorry! No Web Storage support..");
}

export default function App(){
    // On first load, try to restore the session from the HttpOnly refresh cookie
    // (silent /auth/refresh) before routing — so a logged-in user isn't bounced to
    // /Login on a page refresh. No password involved.
    const [booting, setBooting] = useState(true);
    useEffect(() => {
        let mounted = true;
        bootstrapAuth().finally(() => { if (mounted) setBooting(false); });
        return () => { mounted = false; };
    }, []);
    if (booting) return <Loader/>;
    return(
        <BrowserRouter>
            <Switch>
                <Route exact path = "/Login">
                    <Login/>
                </Route>
                <PrivateRoute path = "/">
                    <Main/>
                </PrivateRoute>
            </Switch>
        </BrowserRouter>

    );
}

function PrivateRoute({location, children, ...rest }){
    const isAuthenticated = useMyStore(state => state.isAuthenticated);
    return(
        <Route {...rest}>
            {isAuthenticated ?
            children
            :
            <Redirect
                to = {{
                pathname: "/Login",
                state: { from: location }
            }}/>
        }

        </Route>
    );
}